import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class FullScreenLoaderService {
  private is_loading = new BehaviorSubject(false);
  private message = new BehaviorSubject("");
  public listener_loading = this.is_loading.asObservable();
  public listener_message = this.message.asObservable();

  constructor() {}

  public show(message: string = ""): void {
    this.is_loading.next(true);
    this.message.next(message);
  }
  public hide(): void {
    this.is_loading.next(false);
    this.message.next("");
  }
}
